import { cn } from '../utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        // `accent` is the HOVER role, and in creator light it resolves to
        // `surface-3` — pale MINT — so every loading bar on a light dashboard
        // pulsed green. Dark is fine (`surface-3` is #2A2A2A there), and under
        // `visitor` the legacy `--accent` is a neutral #F5F5F5, so only the
        // creator-light case is overridden: `raise` is the ink that inverts per
        // theme, and at 10% it reads as a skeleton on ANY ground — 1.25:1 on a
        // white card, and it follows a `surface-2` well down too.
        'bg-accent theme-light:bg-raise/10 animate-pulse rounded-md',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
